import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getExtraCostTypes,
  createExtraCostType,
  updateExtraCostType,
  deleteExtraCostType,
  type CreateExtraCostTypeInput,
  type UpdateExtraCostTypeInput,
} from '../services/api/employeeExtraCostTypes';

export function useExtraCostTypes() {
  return useQuery({
    queryKey: ['employeeExtraCostTypes'],
    queryFn: getExtraCostTypes,
  });
}

export function useCreateExtraCostType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateExtraCostTypeInput) => createExtraCostType(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employeeExtraCostTypes'] });
    },
  });
}

export function useUpdateExtraCostType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...input }: { id: number } & UpdateExtraCostTypeInput) => updateExtraCostType(id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employeeExtraCostTypes'] });
    },
  });
}

export function useDeleteExtraCostType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteExtraCostType(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['employeeExtraCostTypes'] });
    },
  });
}
